export default function openSms(phone) {
  if (!phone) return false;

  if (window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(
      JSON.stringify({ data: { openSms: { phone } } })
    );
    return true;
  }

  return false;
}
